import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import * as Sentry from "@sentry/react";

const SentryRouteLogger = () => {
  const location = useLocation();

  useEffect(() => {
    const path = `${location.pathname}${location.search}${location.hash}`;
    Sentry.addBreadcrumb({
      category: "navigation",
      message: `Navigated to ${path}`,
      level: "info",
    });
    Sentry.logger.info("route_navigate", { path });
  }, [location]);

  return null;
};

export default SentryRouteLogger;
